import { faTable } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { editorButtonToggle } from './EditorInput.css'

export const TableButton = ({ editor }: { editor: Editor }) => (
  <Tooltip direction="top" text="Insérer un tableau" asChild>
    <button
      type="button"
      className={editorButtonToggle}
      aria-label="Insérer un tableau"
      onClick={() =>
        editor
          .chain()
          .focus()
          .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
          .run()
      }
    >
      <FontAwesomeIcon icon={faTable} />
    </button>
  </Tooltip>
)
